export default [
  {
    category: 'tagboard',
    element: 'social-display',
    title: 'Social Graphic',
    icon: 'far fa-desktop fa-fw',
    description: 'Embed a social graphic.',
    premium: false,
    limitedElement: ['social-data', 'social-display'],
    maxElements: 1,
    test: 'social-display',
    ldFlag: 'has-social-display-graphic-element', // TODO: Remove once fully released
  },
  {
    category: 'tagboard',
    element: 'poll-display',
    title: 'Poll Graphic',
    icon: 'far fa-poll-h fa-fw',
    description: 'Embed a poll graphic.',
    premium: false,
    limitedElement: ['poll-display'],
    maxElements: 1,
    test: 'poll-display',
    ldFlag: 'has-poll-display-graphic-element', // TODO: Remove once fully released
  },
  {
    category: 'tagboard',
    element: 'shoppable',
    title: 'Shoppable',
    icon: 'far fa-cart-plus',
    description: 'Add shoppable products.',
    premium: false,
    limitedElement: ['shoppable'],
    maxElements: 1,
    test: 'shoppable',
  },
  {
    category: 'tagboard',
    element: 'qrcode',
    title: 'QR Code',
    icon: 'far fa-qrcode fa-fw',
    description: 'Scannable QR code.',
    test: 'qrcode',
  },
  {
    category: 'tagboard',
    element: 'frame',
    title: 'Browser Source',
    icon: 'far fa-browser fa-fw',
    description: 'Embed a live webpage.',
    test: 'frame',
    ldFlag: 'show-graphics-iframe-element', // TODO: Remove when fully released
  },
  {
    category: 'tagboard',
    element: 'slideshow',
    title: 'Slideshow',
    icon: 'far fa-presentation fa-fw',
    description: 'Cycle multiple basics.',
    test: 'slideshow',
  },
  {
    category: 'tagboard',
    element: 'marquee',
    title: 'Ticker',
    icon: 'fak fa-regular-input-text-circle-arrow-left fa-fw',
    description: 'Scrolling ticker strip.',
    test: 'marquee',
  },
];
